<div class="">
    <h3 class="title">
        {{ dataProperties.tableTitle }}
    </h3>
    <div (click)="clickHandler()" class="view-all-link">View All</div>
</div>

<div>
    <kendo-grid
        class="lg-kendo-grid ranking-table lg-scrollbar"
        [data]="gridView"
        [skip]="skip"
        [height]="600"
        [loading]="dataProperties.isLoading"
        [sortable]="sortable"
        [sort]="rankEntrySort"
        [pageSize]="dataProperties.tablePageSize"
        [scrollable]="scrollable"
        [style]="{ cursor: 'pointer' }"
        (cellClick)="cellClickHandler($event)"
        (sortChange)="sortChange($event)"
    >
        <ng-template kendoGridNoRecordsTemplate>
            <div
                class="no-data-message-area"
                *ngIf="!dataProperties.isLoading && !dataProperties.hasData"
            >
                <no-data-screen [noDataType]="noDataType"></no-data-screen>
            </div>
        </ng-template>
        <kendo-grid-column field="rank" title="Rank" [headerClass]="'reports-header'" [width]="90">
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex>
                {{ dataItem.rank }}
            </ng-template>
            <ng-template
                *ngIf="dataProperties.showFooter"
                kendoGridFooterTemplate
                let-column
                let-columnIndex="columnIndex"
            >
                <span class="footerStyle">Total</span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column
            field="displayName"
            title="Name"
            [headerClass]="'reports-header'"
            [width]="150"
        >
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex>
                {{ dataItem.displayName }}
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column
            field="displayScore"
            title="Avg Score"
            [headerClass]="'reports-header'"
            [width]="110"
        >
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex>
                <column-bar-graph
                    [value]="dataItem.displayScore"
                    [percent]="dataItem.displayScore"
                    [format]="'number'"
                >
                </column-bar-graph>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column
            field="displayVolume"
            title="Total Volume"
            [headerClass]="'reports-header'"
            [width]="160"
        >
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex>
                <column-bar-graph
                    [value]="dataItem.displayVolume"
                    [percent]="dataItem.volumePct"
                    [format]="'currency'"
                >
                </column-bar-graph>
            </ng-template>
            <ng-template
                *ngIf="dataProperties.showFooter"
                kendoGridFooterTemplate
                let-column
                let-columnIndex="columnIndex"
            >
                <span class="footerStyle">{{ volTotal | currency: 'USD':'symbol':'1.0-0' }}</span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column
            field="displayUnits"
            title="Total Units"
            [headerClass]="'reports-header'"
            [width]="100"
        >
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex>
                <column-bar-graph [value]="dataItem.displayUnits" [percent]="dataItem.unitsPct">
                </column-bar-graph>
            </ng-template>
            <ng-template
                *ngIf="dataProperties.showFooter"
                kendoGridFooterTemplate
                let-column
                let-columnIndex="columnIndex"
            >
                <span class="footerStyle">{{ unitTotal }}</span>
            </ng-template>
        </kendo-grid-column>
    </kendo-grid>
</div>
